<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-06-27 15:12:46
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-12 10:32:28
 * @FilePath: \合联\oms\src\view\costRule\deliveryCostQuoteRule\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/priceRule/fordelQuoteRule";
export default {
  name: "fordelQuoteRule",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                clearance: this.list,
              });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1000,
              styles: {
                top: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              first_fee: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              first_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              first_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              clearance_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              clearance_vat: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              transport_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              transport_fee: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              start_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
              end_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            {
              client_id: 24,
              country: 12,
              first_type: 12,
              first_currency: 12,
              first_fee: 12,
              transport_currency: 12,
              transport_fee: 12,
              start_time: 12,
              end_time: 12,
              remarks: 24,
              clearance_currency: 12,
              clearance_vat: 12,
              temp: 24,
            },
          ],
          fields: [
            {
              name: () => this.$tz("清关,规则"),
              key: "temp",
              component: "span",
              colBind: {
                style: {
                  marginBottom: "0px",
                },
              },
            },
            {
              name: this.$tz("客户"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$tz("客户"),
              options: [],
              optionsFn: "getAllClient",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("国家"),
              key: "country",
              component: "Select",
              placeholder: () => this.$tz("国家"),
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
              default: "",
            },
            {
              name: () => this.$tz("开始时间"),
              key: "start_time",
              placeholder: () => this.$tz("开始时间"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "date",
              },
            },
            {
              name: () => this.$tz("结束时间"),
              key: "end_time",
              placeholder: () => this.$tz("结束时间"),
              component: "DatePicker",
              disabledDate: true,

              bind: {
                type: "date",
              },
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
            },
            {
              name: this.$tz("头程,计费,单价"),
              key: "first_fee",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("头程,计费,类型"),
              key: "first_type",
              component: "Select",
              placeholder: () => this.$tz("头程,计费,类型"),
              options: [],
              optionsFn: "costChargeType",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("头程,计费,币种"),
              key: "first_currency",
              component: "Select",
              placeholder: () => this.$tz("头程,计费,币种"),
              options: [],
              optionsFn: "getCurrency",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("清关费,VAT"),
              key: "clearance_vat",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("清关费,币种"),
              key: "clearance_currency",
              component: "Select",
              placeholder: () => this.$tz("清关费,币种"),
              options: [],
              optionsFn: "getCurrency",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("运输费"),
              key: "transport_fee",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("运输费,币种"),
              key: "transport_currency",
              component: "Select",
              placeholder: () => this.$tz("运输费,币种"),
              options: [],
              optionsFn: "getCurrency",
              optionsKey: "",
              default: "",
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                name: () => this.$tz("最小重量"),
                key: "lower_weight",
                component: "Input",
                placeholder: () => this.$tz("最小重量"),
              },
              {
                name: () => this.$tz("最大重量"),
                key: "upper_weight",
                component: "Input",
                placeholder: () => this.$tz("最大重量"),
              },
              {
                name: () => this.$tz("单价"),
                key: "price",
                component: "Input",
                placeholder: () => this.$tz("单价"),
              },
              {
                name: this.$tz("计费方式"),
                key: "charge_type",
                component: "Select",
                placeholder: () => this.$tz("计费方式"),
                options: [],
                optionsFn: "costChargeType",
                optionsKey: "",
                default: "",
                bind: {
                  transfer: true,
                },
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "success",
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "deleteFun",
                    bind: {
                      type: "error",
                    },
                    disabled() {
                      return this.$modal.list.length === 1;
                    },
                  },
                ],
                methods: {
                  add({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex + 1, 0, {});
                  },
                  deleteFun({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex, 1);
                  },
                },
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("请选择,日期,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "COST_DELIVERY_RULE_DATA_TYPE",
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "country",
            placeholder() {
              return this.$tz("请选择,国家");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
          {
            key: "currency",
            placeholder() {
              return this.$tz("请选择,币种");
            },
            component: "Select",
            options: [],
            optionsFn: "getCurrency",
            optionsKey: "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
              id: 1793,
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
                this.list.push({
                  lower_weight: "",
                  upper_weight: "",
                  charge_type: "",
                  price: "",
                });
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$tz("客户名称"),
          key: "client_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("country_t"),
          key: "country",
          minWidth: 130,
        },
        {
          name: () => this.$tz("头程,计费,币种"),
          key: "first_currency",
          minWidth: 110,
        },
        {
          name: () => this.$tz("头程,计费,单价"),
          key: "first_fee",
          minWidth: 110,
        },
        {
          name: () => this.$tz("头程,计费,方式"),
          key: "first_type_txt",
          minWidth: 110,
        },
        {
          name: () => this.$tz("清关费,币种"),
          key: "clearance_currency",
          minWidth: 110,
        },
        {
          name: () => this.$tz("清关费,VAT"),
          key: "clearance_vat",
          minWidth: 110,
        },
        {
          name: () => this.$tz("运输费,币种"),
          key: "transport_currency",
          minWidth: 110,
        },
        {
          name: () => this.$tz("运输费"),
          key: "transport_fee",
          minWidth: 110,
        },
        {
          name: () => this.$tz("开始时间"),
          key: "start_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("结束时间"),
          key: "end_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$tz("清关费,规则"),
          key: "clearance_txt",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
              id: 1793,
            },
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              id: 1794,
            },
          ],
          methods: {
            update({ row }) {
              this.getModal("add").open(row, function () {
                this.list = row.clearance;
                this.setTitle(this.$tz("编辑"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>